import { General } from "../../siteManagement/general.js";
import { Sheet, SheetEventType } from "../../siteManagement/sheet.js";
import { BaseColumn, EditableGrid, field, InGridButtonClickParams, InGridToolBarButton, Schema } from "../core/components/editableGrid/editableGrid.js";
import { ToolBar, ToolBarInGridButtonType, ToolBarStandardButtonType } from "../core/components/toolBar.js";
import { Config } from "../core/config/config.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { Helper } from "../core/util/helper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { IngridHelper } from "../core/util/ingridHelper.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { AddressAppProps } from "./address.js";
import React from "react";
export default class OpeningHoursInGrid extends React.Component<AddressAppOpeningHoursProps, AddressAppOpeningHoutsState>{
    private gridOptions = {};
    editableGridRef: EditableGrid;
    private sheet: Sheet;
    private disableChanged: boolean = false;

    constructor(props) {
        super(props);
        this.state = {
            gridData: [],
            Columns: null,
            Schema: null,
            LastEdited: null
        }
        this.sheet = General.Sheet.Manager.getTopMostVisibleSheet();
        this.gridOptions = this.props.context.openingHoursInGrid;
    }

    componentDidMount() {
        this.bindToSaveSuccessfully();
        this.getGridData();
        new IngridHelper(this).initGridSettings(this.gridOptions).then(result => {
            let gridOptions = result;
            this.setState({
                Columns: gridOptions.Columns, Schema: gridOptions.Schema
            }, () => {
                if (Helper.hasValue(this.editableGridRef) &&
                    Helper.hasValue(this.editableGridRef.getGrid()) &&
                    this.editableGridRef.getGrid().columns) {

                    this.editableGridRef.getGrid().bind("headerCheckBoxClick", this.onHeaderCheckBoxClick);

                    //remove column
                    this.editableGridRef.getGrid().hideColumn("DayOfWeek");
                    //remove group-header 
                    let el = $(this.editableGridRef.getGrid).find(".k-grouping-header");
                    el.hide();
                    //remove main checkbox
                    el = $(this.editableGridRef.getGrid).find(".k-header").find(".k-checkbox");
                    el.hide();
                    //set "tag" label
                    el = el.parents("th");
                    el.text(Helper.getTranslation("Standard.Tag")).wrapInner("<strong />");
                }
            });
        });
    }

    public getEntries(): any {
        return this.editableGridRef.getData();
    }

    private async getGridData() {
        let url = "AddressOpeningHours/GetOpeningHours?id=" + encodeURIComponent(this.props.entity.AdrNr);
        let result = await HTTPService.get<JsonResultClass<AddressOpeningHours[]>>(url);
        if (result.Code == 0) {
            this.props.entity.OpeningHoursLoaded = true;
            this.setState({ gridData: result.Data }, () => {
                this._validateEntries(false, true, this.editableGridRef?.getDataSource());
                this.disableChanged = false;
            })
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    };

    private _indexOfLast(entries: AddressOpeningHours[], dayOfWeek: string | number) {
        const data = this.editableGridRef.getData();
        const list = entries.filter(x => x.DayOfWeek == dayOfWeek as string);
        if (list.length > 0)
            return data.indexOf(list[list.length - 1]);
        else
            return -1;
    }

    private _getGridData(): AddressOpeningHours[] {
        let gridData: any = this.editableGridRef.getData();
        return gridData as AddressOpeningHours[];
    }

    private _dateRangeOverlaps(a_start, a_end, b_start, b_end) {
        if (a_start <= b_start && b_start <= a_end) return true; // b starts in a
        if (a_start <= b_end && b_end <= a_end) return true; // b ends in a
        if (b_start < a_start && a_end < b_end) return true; // a in b
        return false;
    }
    private _validateEntries(checkOnly: boolean, showMessage: boolean, dataSource: kendo.data.DataSource) {
        if (!Helper.hasValue(dataSource))
            return false;

        let list: AddressOpeningHours[] = [];

        let entries: any = dataSource.data();
        for (let d = 1; d < 8; d++) {
            let dayEntries = entries.filter(x => x.DayOfWeek == d.toString() && !(x.StartTime == 0 && x.EndTime == 0));
            const l = dayEntries.length;
            if (l > 1) {
                for (let i = 0; i < l - 1; i += 1) {
                    for (let j = i + 1; j < l; j += 1) {
                        const overlapped = dayEntries[j];
                        if (this._dateRangeOverlaps(dayEntries[i].StartTime, dayEntries[i].EndTime, overlapped.StartTime, overlapped.EndTime)) {
                            if (list.filter(x => x.Id == overlapped.Id).length == 0)
                                list.push(overlapped);
                        }
                    }
                }
            }
        }
        list = list.filter(x => !(x.StartTime == 0 && x.EndTime == 0));

        if (!checkOnly) {
            //remove dummies 
            this.disableChanged = true;
            entries.filter(x => x.StartTime == 0 && x.EndTime == 0).forEach(d => {
                const dataRow = dataSource.getByUid((d as any).uid);
                dataSource.remove(dataRow);
            });
            this.disableChanged = false;

            //remove overlapped
            list.forEach(d => {
                const dataRow = dataSource.getByUid((d as any).uid);
                dataSource.remove(dataRow);
            });

            //sort
            dataSource.data().sort((a, b) => {
                if (a.StartTime == b.StartTime) return 0;
                if (a.StartTime == 0 && a.EndTime == 0) return 1;
                if (b.StartTime == 0 && b.EndTime == 0) return -1;
                if (a.StartTime > b.StartTime) return 1;
                return -1;
            });

            //add dummies back
            this._updateDummyEntries(dataSource);
        }


        if (list.length > 0 && showMessage) {
            const info = list.map(l => Helper.dates.getDayOfWeekLabel(Number(l.DayOfWeek)) + ", " +
                Helper.dates.getMinToHHMM(l.StartTime) + " - " + Helper.dates.getMinToHHMM(l.EndTime));
            NotificationHelper.showWarningMessage(Helper.getTranslation("Standard.RemoveOverlaps") + ": <br/>" + info.join('<br/>'));
        }

        return list.length > 0;
    }
    private _updateDummyEntries(dataSource: kendo.data.DataSource) {
        let changed = false;

        this.disableChanged = true;

        let entries: any = dataSource.data();
        for (let i = 1; i < 8; i++) {
            if (entries.filter(x => x.DayOfWeek == i.toString()).length > 0 &&
                entries.filter(x => x.DayOfWeek == i.toString() && x.StartTime == 0 && x.EndTime == 0).length == 0) {
                const idx = this._indexOfLast(entries, i);
                if (idx > -1) {
                    let newEntity = this.createNewEntity(i);
                    dataSource.add(newEntity);
                    changed = true;
                }
            }
        }

        entries = dataSource.data();
        for (let i = 1; i < 8; i++) {
            if (entries.filter(x => x.DayOfWeek == i.toString()).length == 0) {
                let newEntity = this.createNewEntity(i);
                dataSource.add(newEntity);
                changed = true;
            }
        }

        entries = dataSource.data();
        for (let i = 1; i < 8; i++) {
            let entriesFiltered =
                entries.filter(x => x.DayOfWeek == i.toString() && x.StartTime == 0 && x.EndTime == 0);
            if (entriesFiltered.length > 1) {
                for (let j = entriesFiltered.length; j > 1; j--) {
                    const item = dataSource.get(entriesFiltered[j - 1].Id);
                    const dataRow = dataSource.getByUid(item.uid);
                    dataSource.remove(dataRow);
                    changed = true;
                }
            }
        }

        this.disableChanged = false;

        return changed;
    }

    private createNewEntity = (day?: number | string): AddressOpeningHours => {
        let entity: AddressOpeningHours = {
            Id: kendo.guid(),
            Address: this.props.entity.AdrNr,
            StartTime: 0,
            EndTime: 0
        }
        if (day) {
            entity.DayOfWeek = (day as number).toString();
            entity.DayOfWeekLabel = Helper.dates.getDayOfWeekLabel(day as number);
        }
        return entity;
    }
    private deleteSelectedEntries(p: InGridButtonClickParams) {
        if (p.selectedItems.length > 0) {
            DialogHelper.confirm(Config.translations.deleteMessage).then(isOk => {
                if (isOk) {
                    p.actions.deleteSelected(false);
                    this._validateEntries(false, true, p.dataSource);
                }
            });
        }
        else {
            DialogHelper.alert(Helper.getTranslation("WebSMS.WeeklyReport.PleaseSelectEntry"));
        }
    }
    private _copyToOneDay = (selected: AddressOpeningHours[], day: string, dataSource: kendo.data.DataSource) => {
        const dayEntries = this._getGridData().filter(x => x.DayOfWeek == day.toString() &&
            !(x.StartTime == 0 && x.EndTime == 0));
        dayEntries.forEach(d => {
            const dataRow = dataSource.getByUid((d as any).uid);
            dataSource.remove(dataRow);
        });

        selected.forEach(s => {
            let newEntry = this.createNewEntity(day);
            newEntry.StartTime = s.StartTime;
            newEntry.EndTime = s.EndTime;
            dataSource.add(newEntry);
        })
    }
    private copySelectedEntries(copy: "copy_all" | "copy_work" | "copy_next", p: InGridButtonClickParams) {
        let selected = p.selectedItems.filter(x => !(x.StartTime == 0 && x.EndTime == 0)) as AddressOpeningHours[];
        if (copy == "copy_all") {
            for (let i = 1; i < 8; i++) {
                this._copyToOneDay(selected, i.toString(), p.dataSource);
            }
        } else if (copy == "copy_next") {
            this._copyToOneDay(selected, (Number(selected[0].DayOfWeek) + 1).toString(), p.dataSource);
        } else {
            this._copyToOneDay(selected, "2", p.dataSource);
            this._copyToOneDay(selected, "3", p.dataSource);
            this._copyToOneDay(selected, "4", p.dataSource);
            this._copyToOneDay(selected, "5", p.dataSource);
            this._copyToOneDay(selected, "6", p.dataSource);
        }

        p.actions.clearSelection();
        this._validateEntries(false, true, p.dataSource);
    }

    //function for kendo.Template 
    public HeaderCheckBoxClick = (checkBox) => {
        $("#" + $(checkBox).parents(".k-grid")[0].id)
            .data("kendoGrid")
            .trigger("headerCheckBoxClick", checkBox);
    }

    private onHeaderCheckBoxClick(checkBox) {
        const day = checkBox.id[checkBox.id.length - 1];
        const checked = checkBox.checked;
        const grid = $("#" + $(checkBox).parents(".k-grid")[0].id).data("kendoGrid");

        if (checked) {
            let data: any = grid.dataSource.data();
            let entries = data as AddressOpeningHours[];
            entries.filter(x => x.DayOfWeek == day).forEach(itemData => {
                const item = grid.dataSource.get(itemData.Id);
                const tr = $("[data-uid='" + item.uid + "']", grid.tbody);
                grid.select(tr);
            });
            grid.trigger("change");
        } else {
            let list: JQuery<HTMLElement>[] = [];
            let data: any = grid.dataSource.data();
            let entries = data as AddressOpeningHours[];
            entries.filter(x => x.DayOfWeek != day).forEach(itemData => {
                const item = grid.dataSource.get(itemData.Id);
                const tr = $("[data-uid='" + item.uid + "']", grid.tbody);
                if (tr.hasClass("k-state-selected"))
                    list.push(tr);
            });

            grid.clearSelection();
            list.forEach(tr => {
                grid.select(tr);
            })
            grid.trigger("change");
        }
    }

    private _isOneSelected = (p: InGridButtonEnabledParams) => {
        return p.hasSingleSelection && !(p.selectedItems[0].StartTime == 0 && p.selectedItems[0].EndTime == 0)
    };

    private _isSelected = (p: InGridButtonEnabledParams) => {
        return p.hasSelection && p.selectedItems.filter(x => !(x.StartTime == 0 && x.EndTime == 0)).length > 0;
    };

    private _handleSelectionChange = (e: kendo.ui.GridChangeEvent) => {
        const items = e.sender.dataSource.data();

        const rows = e.sender.select();
        const dataItems = rows.map((index, row) => { return e.sender.dataItem(row) });
        const selected = dataItems.toArray();

        for (let i = 1; i < 8; i++) {
            const allItems = items.filter(c => (c as AddressOpeningHours).DayOfWeek == i.toString()).length;
            const selectedItems = selected.filter(c => (c as AddressOpeningHours).DayOfWeek == i.toString()).length;

            const el = $(e.sender).find("#checkBoxDayOfWeekGroup_" + i.toString());
            el.prop("checked", allItems == selectedItems);
        }
        this.setState({});
    }

    private _handleOnEditEnd = (e: kendo.ui.GridCellCloseEvent) => {
        const field = this.editableGridRef.getGrid().columns[e.container.index() - 1].field;
        if (field == "StartTime") {
            const endTime = e.model.get("EndTime");
            const startTime = e.model.get("StartTime");
            if (startTime > 0 && (endTime == 0 || startTime > endTime)) {
                if (startTime + 60 > 1439)
                    e.model.set("EndTime", 1439);
                else
                    e.model.set("EndTime", startTime + 60);
            }

        }

        if (field == "EndTime") {
            const endTime = e.model.get("EndTime");
            const startTime = e.model.get("StartTime");

            let canUpdate = false;
            if (startTime == 0) {
                //prior row exists, to check or we can update 00:00?
                let entries = this.getEntries() as AddressOpeningHours[];
                entries = entries.filter(x => x.DayOfWeek == e.model.get("DayOfWeek") && !(x.StartTime == 0 && x.EndTime == 0));
                const idx = entries.findIndex(x => x.Id == e.model.get("Id"));
                if (idx > 0)
                    canUpdate = true;
            }

            if (endTime > 0 && (canUpdate || startTime > endTime)) {
                if (endTime - 60 < 0)
                    e.model.set("StartTime", 0)
                else
                    e.model.set("StartTime", endTime - 60);
            }

        }

        if (this._updateDummyEntries(e.sender.dataSource)) {
            //set focus back!!!    
            setTimeout(() => {
                this.editableGridRef.getGrid().current(e.container);
            });
        }
    }
    private createGrid = () => {
        let editable = this.props.entity.RecordRight.CanWrite;

        const buttons: Array<InGridToolBarButton> = [];
        buttons.push({ type: ToolBarInGridButtonType.EDIT, id: "edit", enabled: (p) => editable && this._isOneSelected(p) });
        buttons.push({ type: ToolBarInGridButtonType.DELETE, id: "delete", enabled: (p) => editable && this._isSelected(p) });
        buttons.push({
            type: ToolBarInGridButtonType.CUSTOM,
            id: "validate",
            enabled: (p) => editable && this._validateEntries(true, false, p.dataSource),
            caption: Helper.getTranslation("Standard.Validate"),
            iconClass: "fa-solid fa-list-check"
        });
        buttons.push({
            type: ToolBarInGridButtonType.CUSTOM,
            id: "copy",
            enabled: (p) => editable && p.hasSelection && this._isOneDaySelected(p),
            caption: Helper.getTranslation("Standard.Kopieren"),
            iconClass: "fa-solid fa-copy"
        });

        return <EditableGrid
            data={this.state.gridData}
            id="openingHoursInGrid"
            columns={this.state.Columns}
            schema={this.state.Schema}
            ref={(ref) => this.editableGridRef = ref}
            validatable={false}
            editable={editable}
            onDataChanged={this.onGridDataChanged}
            onEditEnd={this._handleOnEditEnd}
            onSelectionChange={this._handleSelectionChange}
            onSaveSuccesfully={this.updateSaveStateOfSheet}
            buttons={buttons}
            onButtonClick={this.handleButtonClick}
            helpEditUrl={this.props.helpUrl}
            {...{ HeaderCheckBoxClick: this.HeaderCheckBoxClick }} />
    }

    private flag: boolean = false;

    onGridDataChanged = async (action: string, fieldName: string, dataItems: any) => {
        if (action == "itemchange") {
            if (!this.flag && (fieldName == "EndTime" || fieldName == "StartTime")) {
                this.flag = true;

                if (fieldName == "EndTime")
                    this.editableGridRef.refreshColumnTemplate(dataItems[0], "StartTime");
                if (fieldName == "StartTime")
                    this.editableGridRef.refreshColumnTemplate(dataItems[0], "EndTime");

                this.flag = false;
            }
        }

        if (!this.disableChanged)
            this.sheet.trigger(SheetEventType.Custom, { cmd: "addressChanged" })
    }

    private updateSaveStateOfSheet = () => {
        this.sheet.trigger(SheetEventType.Custom, { cmd: "addressChanged" })
    }

    private bindToSaveSuccessfully = () => {
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.bind(SheetEventType.SavedSuccessfully, () => {
            this.getGridData();
        });
    }

    private _isOneDaySelected = (p: InGridButtonEnabledParams) => {
        const selected = p.selectedItems.filter(x => !(x.StartTime == 0 && x.EndTime == 0));

        let count = 0;
        let day = "0";
        selected.forEach(s => {
            if (day != s.DayOfWeek) {
                day = s.DayOfWeek;
                count++;
            }
        })

        return count == 1;
    }

    handleButtonClick = async (p: InGridButtonClickParams) => {
        switch (p.id) {
            case "edit":
                p.actions.editSelected();
                this._updateDummyEntries(p.dataSource);
                break;
            case "delete":
                this.deleteSelectedEntries(p);
                this._updateDummyEntries(p.dataSource);
                break;
            case "copy":
                if (p.selectedItems.length > 0) {
                    const lastDayHours = p.selectedItems.filter(x => x.DayOfWeek == "7" &&
                        !(x.StartTime == 0 && x.EndTime == 0)).length == 0;

                    let arr: { label: string, value: any, primary?: boolean }[] = [];
                    arr.push({ label: Helper.getTranslation("Standard.CopyAllDays"), value: "copy_all", primary: false });
                    arr.push({ label: Helper.getTranslation("Standard.CopyWorkDays"), value: "copy_work", primary: false });
                    if (lastDayHours)
                        arr.push({ label: Helper.getTranslation("Standard.CopyNextDay"), value: "copy_next", primary: false });

                    const res = await DialogHelper.choose(Helper.getTranslation("Standard.CopySelectAction"), arr, true, 1050);
                    if (res == "copy_all" || res == "copy_work" || res == "copy_next")
                        this.copySelectedEntries(res, p);
                } else {
                    DialogHelper.alert(Helper.getTranslation("WebSMS.WeeklyReport.PleaseSelectEntry"));
                }
                break;
            case "validate":
                this._validateEntries(false, true, p.dataSource);
                break;
        }
    }

    render() {
        let content = null;
        if (Helper.hasValue(this.state.Columns)) {
            let grid = this.createGrid();
            let schema = this.state.Schema;
            schema.Id = "Id";
            schema.fields["Id"] = new field("string");
            content = <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                {grid}
            </div>
        }

        return (<>
            {content}
        </>);
    }
}

interface AddressAppOpeningHoutsState {
    gridData: AddressOpeningHours[];
    Schema: Schema;
    Columns: BaseColumn[];
    LastEdited: any;
}

export interface AddressAppOpeningHoursProps extends AddressAppProps {

}

export interface AddressOpeningHours {
    Id?: string;
    Address?: string;
    DayOfWeek?: string;
    DayOfWeekLabel?: string;
    StartTime?: number;
    EndTime?: number;
    StartTimeStr?: string;
    EndTimeStr?: string;
}

export interface InGridButtonEnabledParams {
    hasSingleSelection: boolean;
    hasSelection: boolean;
    selectedItems: any[];
    dataSource: kendo.data.DataSource;
}